var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCarbonSearch({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.378 15.16L11.602 11.1476C12.5094 9.99 12.9619 8.50527 12.8653 7.00224C12.7688 5.4992 12.1306 4.09358 11.0836 3.07778C10.0366 2.06199 8.66136 1.51423 7.24397 1.54845C5.82657 1.58267 4.47616 2.19624 3.47366 3.26152C2.47115 4.3268 1.89374 5.76177 1.86153 7.26792C1.82932 8.77406 2.34481 10.2354 3.30075 11.348C4.25668 12.4606 5.57947 13.1387 6.99394 13.2413C8.40841 13.3439 9.80564 12.863 10.895 11.8988L14.671 15.9113L15.378 15.16ZM2.87799 7.41033C2.87799 6.46459 3.14191 5.54008 3.63637 4.75372C4.13084 3.96736 4.83364 3.35447 5.65591 2.99254C6.47818 2.63062 7.38298 2.53593 8.25589 2.72043C9.12881 2.90494 9.93063 3.36036 10.56 4.0291C11.1893 4.69785 11.6179 5.54988 11.7915 6.47745C11.9652 7.40503 11.876 8.36648 11.5354 9.24024C11.1949 10.114 10.6181 10.8608 9.87805 11.3862C9.13803 11.9117 8.268 12.1921 7.37799 12.1921C6.18492 12.1907 5.0411 11.6865 4.19747 10.79C3.35384 9.89356 2.87931 8.67811 2.87799 7.41033Z",
    fill: "#616161"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarbonSearch);
export default __webpack_public_path__ + "static/media/carbon_search.8339a4498cf2354956b12658bfd650a3.svg";
export { ForwardRef as ReactComponent };